import { InlineLoading, Modal, TextInput, Layer } from '@carbon/react';
import styles from './add-scenario-name-modal.module.scss';
import { useParams } from 'react-router-dom';
import { dcaScenarioDataAtom } from './atoms';
import { useAtomValue } from 'jotai';
import { useScenarioForm } from './contexts';
import classNames from 'classnames';
import { TanstackFieldWrapper } from 'components/form-fields-2';

interface AddScenarioNameModalProps {
  onClose: () => void;
}

export const AddScenarioNameModal = ({
  onClose,
}: AddScenarioNameModalProps) => {
  const { form, selectedConfig, handleSubmitForm } = useScenarioForm();
  const { id: scenarioId = null } = useParams<{ id?: string }>();
  const dcaScenarioDataState = useAtomValue(dcaScenarioDataAtom);

  return (
    <form.Subscribe selector={(state) => state.values.globalConfig}>
      {(globalConfig) => (
        <Modal
          open
          size="md"
          modalHeading="Save DCA Scenario"
          className={classNames(styles.addScenarioNameModal, {
            [styles.disableSecondaryButton]: dcaScenarioDataState.loading,
          })}
          secondaryButtonText="Cancel"
          primaryButtonText={
            <div className={styles.inlineLoadingContainer}>
              {' '}
              {dcaScenarioDataState.loading ? <InlineLoading /> : 'Save'}
            </div>
          }
          onRequestClose={() => {
            if (!dcaScenarioDataState.loading) onClose();
          }}
          onRequestSubmit={async () => {
            await handleSubmitForm({
              dcaScenarioId: scenarioId,
              areaConfigId: selectedConfig?.href ? selectedConfig.id : null,
            });
            onClose();
          }}
          onSecondarySubmit={() => {
            if (!dcaScenarioDataState.loading) onClose();
          }}
          primaryButtonDisabled={!globalConfig?.name}
          preventCloseOnClickOutside
          closeButtonLabel="Close"
          aria-label="Save DCA Scenario"
        >
          <form.Subscribe selector={(state) => state.values.globalConfig}>
            <form.Field name="globalConfig.name">
              {(field) => (
                <TanstackFieldWrapper<string> field={field}>
                  {(props) => (
                    <Layer>
                      <TextInput
                        id="globalConfig.name"
                        labelText="Save the new DCA scenario to add more Area Configs* (required)"
                        size="lg"
                        placeholder="Enter Name for the New DCA scenario"
                        disabled={dcaScenarioDataState.loading}
                        {...props}
                        onChange={({ target: { value } }) =>
                          props.onChange(value)
                        }
                      />
                    </Layer>
                  )}
                </TanstackFieldWrapper>
              )}
            </form.Field>
          </form.Subscribe>
        </Modal>
      )}
    </form.Subscribe>
  );
};
